import * as React from "react";
import { forwardRef } from "react";
const SvgDone = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, strokeWidth: 2, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 6.5L9 17.5L4 12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDone);
export default ForwardRef;
